import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';
import ImprContr from '../../../components/funcionales/imprcontr'

//Lista de OS
const DetalleOS = ({handleClickidListaOS, handleClickDetOS, elemento, styles, opcionOdeS, listDet, empresaArchFE}) => {
  let estado = elemento.estadoOS
  if(opcionOdeS==="ModOdeS"){
    return(
      <tr className='' onClick={(ev)=>handleClickDetOS(ev, elemento)}>
        <td className='' style={elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles}>
            {elemento.numeroOS}</td>
        <td className='' style={{...elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles, color: estado==='ABIERTA'?'yellow':'white',
            background: elemento.numeroOS===listDet.numeroOS?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.estadoOS}</td>

        <td className='' style={{...elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles, color: estado==='CERRADA'&&!elemento.observacCE?'yellow':'white',
            background: elemento.numeroOS===listDet.numeroOS?'linear-gradient(#093189, #1CB5E0, #093189)':''}}
            >{elemento.tipoos.descrTipoOS}</td>
        {empresaArchFE==="codisert" &&
        <td className='' style={elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles}
          >{elemento.descrCategOST?elemento.descrCategOST:""}</td>
        }

        {/* <td className='' style={elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles}
            >{elemento.tipoos.descrTipoOS}</td> */}
        <td className='' style={elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles}
            >{elemento.nombreSolic}</td>
        <td className='' style={elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles}
            >{elemento.horaSolic}</td>
        <td className='' style={elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles}
            >{elemento.impresa?"Si":"No"}</td>
        
        <td className='center aligned' style={elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles}>
          <a className='ui large label' style={styles.styTableInf}><i className='eye center large yellow icon'
            onClick={(ev)=>handleClickidListaOS(ev, elemento)}/></a>
        </td>
      </tr>
    )
  }else{
    return(
      <tr className=''  onClick={(ev)=>handleClickDetOS(ev, elemento)}>
        <td className='' style={elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles}>
            {elemento.numeroOS}</td>
        <td className='' style={{...elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles, color: estado==='ABIERTA'?'yellow':'white',
            background: elemento.numeroOS===listDet.numeroOS?'linear-gradient(#093189, #1CB5E0, #093189)':''}}>{elemento.estadoOS}</td>
        <td className='' style={{...elemento.numeroOS===listDet.numeroOS?styles.styTableSel:styles, color: estado==='CERRADA'&&!elemento.observacCE?'yellow':'white',
            background: elemento.numeroOS===listDet.numeroOS?'linear-gradient(#093189, #1CB5E0, #093189)':''}}
            >{elemento.tipoos.descrTipoOS}</td>

        <td className='center aligned'>
          <button className="ui button" style={{background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
              color: '#89253e'}} onClick={(ev)=>handleClickidListaOS(ev, elemento)}>
            Imprimir contrato
          </button>
        </td>

      </tr>
    )
  }
};

const ListaOS = ({list, styles, opcionOdeS, empresaArchFE, handleClickidListaOS, handleClickDetOS, listDet}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleOS handleClickidListaOS={handleClickidListaOS}
    handleClickDetOS={handleClickDetOS} elemento={elemento} key={elemento._id} styles={styles}
    opcionOdeS={opcionOdeS} listDet={listDet} empresaArchFE={empresaArchFE} />);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class OdeSOS2 extends React.Component {
// const OdeSOS2 = ({autorizacUA, styles, list, numOSAb, handleClick, cliente, handleClickidListaOS}) => {
  // const titulo = `O de S => ${cliente.contrato} ${cliente.nombreCliente} ${cliente.apellidoCliente}`
  
  state={listDet: this.props.list.length>0?this.props.list[0]:{}}

  handleImpContr = async (ev, elemento) => {
  
  // console.log(this.props.cliente)
    ImprContr(elemento, this.props.cliente)
    // ImprContr(idLista, empresa, fechaHoraHoy)
  }
  
  handleClickDetOS = (ev, elemento)=>{
    ev.preventDefault()
    this.setState({listDet: elemento})
  }

  UNSAFE_componentWillReceiveProps(next_props){
    this.setState({listDet: next_props.list.length>0?next_props.list[0]:{}});
  }

  render(){
    const {listDet} = this.state;

    let titulo = `Ordenes de Servicio`
    let a01014501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01014501" );
    if(this.props.opcionOdeS==="ImprContr"){
      titulo = `Imprimir contrato`
      a01014501 = -1
    }

  let estilos = Object.assign({}, this.props.styles.styTableSup, {margin: '0em 0em 0em 0em'})
  // console.log(cliente)
  // console.log(listDet)
  // console.log(this.props.cliente)
  let fechaImpr = "", fechaCanc = "", fechaClose = "", usuarioImpr = "", usuarioCanc = "", usuarioClose = ""
  if(this.props.list.length>0){
    if(listDet.fechaImpr){
      fechaImpr = listDet.fechaImpr.substr(0,10)
      usuarioImpr = listDet.usuarioImpr
    }
    if(listDet.fechaCanc){
      fechaCanc = listDet.fechaCanc.substr(0,10)
      usuarioCanc = listDet.usuarioCanc
    }
    if(listDet.fechaClose){
      fechaClose = listDet.fechaClose.substr(0,10)
      usuarioClose = listDet.usuarioClose
    }  
  }
  // console.log(this.props.empresa.empresaArchFE)
  return (
    <div>
      <List selection>
        <TitDer list={this.props.list} textBoton1={titulo} btnNuevo={a01014501!==-1?"SI":"NO"}
                styles={this.props.styles} handleClick={(this.props.numOSAb===0)?this.props.handleClick:()=>{}}/>
      </List>

      <div>

      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <div>
        {/* style={{color: estado==='ABIERTA'?'yellow':'white'}} */}
          {(this.props.list.length>0) &&
            <div>
              <h1 style={this.props.styles.paraH1}>
                  {this.props.cliente.contrato} - {this.props.cliente.nombreCliente} {this.props.cliente.apellidoCliente} - &nbsp;&nbsp;
                  <span style={this.props.cliente.estadoCliente!=='ACTIVO'?this.props.styles.paraH2_02:this.props.styles.paraH2_01}>
                    {this.props.cliente.estadoCliente}
                  </span>
              </h1>
              <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                OS{listDet.numeroOS} -&nbsp;
                <span style={{color: listDet.estadoOS==='ABIERTA'?'#2C7744':'#302b63'}}>
                    {listDet.estadoOS}
                  </span>
              </p>

              <hr></hr>
              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '14%'}}>
                    <p style={{color: '#302b63', fontStyle: 'italic'}}>
                      Observaciones:
                    </p>
                  </div>
                  <div className="column" style={{width: '14%'}}>
                    <p style={{color: '#302b63', fontStyle: 'italic'}}>
                      Al crear:
                    </p>
                  </div>
                  <div className="column" style={{width: '72%'}}>
                    <p style={{color: '#302b63', fontStyle: 'italic'}}>
                      {listDet.observacAB}
                    </p>
                  </div>
                  <div className="column" style={{width: '14%'}}>
                    <p></p>
                  </div>
                  <div className="column" style={{width: '14%'}}>
                    <p style={{color: '#302b63', fontStyle: 'italic'}}>
                      Al {listDet.estadoOS==="CANCELADA"?"cancelar":"cerrar"}:
                    </p>
                  </div>
                  <div className="column" style={{width: '72%'}}>
                    <p style={{color: '#302b63', fontStyle: 'italic'}}>
                      {listDet.estadoOS==="CANCELADA"?listDet.observacCA:listDet.observacCE}
                    </p>
                  </div>
                </div>
              </div>

              <hr></hr>
              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '34%'}}>
                    <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                      Fecha crea:&nbsp;{listDet.fechaCreate.substr(0,10)}<br/>
                      Usuario crea:&nbsp;{listDet.usuarioCreate}
                    </p>
                  </div>
                  <div className="column" style={{width: '33%'}}>
                    <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                      Fecha impr:&nbsp;{fechaImpr}<br/>
                      Usuario impr:&nbsp;{usuarioImpr}
                    </p>
                  </div>
                  <div className="column" style={{width: '33%'}}>
                    <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                      Fecha {listDet.estadoOS==="CANCELADA"?"canc":"cierre"}:&nbsp;
                      {listDet.estadoOS==="CANCELADA"?fechaCanc:fechaClose}<br/>
                      Usuario {listDet.estadoOS==="CANCELADA"?"canc":"cierra"}:&nbsp;
                      {listDet.estadoOS==="CANCELADA"?usuarioCanc:usuarioClose}
                    </p>
                  </div>
                </div>
              </div>
            <hr></hr>
            </div>
          }

        <table name="histNot" id="histNot" className='ui blue inverted celled selectable table' style={estilos}>
          <thead className=''>
            {this.props.opcionOdeS==="ModOdeS" &&
              <tr className=''>
                <th className='' style={{width: '10%'}}># OS</th>
                <th className='' style={{width: '10%'}}>Estado</th>
                <th className='' style={{width: '17%'}}>Tipo de OS</th>
                {this.props.empresa.empresaArchFE==="codisert" &&
                  <th className='' style={{width: '14%'}}>Categoría</th>
                }
                <th className='' style={{width: '18%'}}>Solicitante</th>
                <th className='' style={{width: '11%'}}>Hora solic</th>
                <th className='' style={{width: '10%'}}>Impresa</th>
                <th className='' style={{width: '10%'}}>Ver</th>
              </tr>
            }
            {this.props.opcionOdeS==="ImprContr" &&
              <tr className=''>
                <th className='' style={{width: '10%'}}># OS</th>
                <th className='' style={{width: '15%'}}>Estado</th>
                <th className='' style={{width: '20%'}}>Tipo de OS</th>
                <th className='' style={{width: '10%'}}>Imprimir contrato</th>
              </tr>
            }
          </thead>
          <ListaOS list={this.props.list} styles={this.props.styles}
                    opcionOdeS={this.props.opcionOdeS} empresaArchFE={this.props.empresa.empresaArchFE?this.props.empresa.empresaArchFE:""}
                    handleClickidListaOS={this.props.opcionOdeS==="ModOdeS"?this.props.handleClickidListaOS:this.handleImpContr}
                    handleClickDetOS={this.handleClickDetOS} listDet={listDet}/>
        </table>
        <p></p>
        </div>
        </div>
      </div>
    </div>
  )
}
};

// export default OdeSOS2


export default OdeSOS2
